import React, { useMemo } from 'react';
import './App.module.css';
import { SiderApp, GoogleLogger } from './components';
import { UserContext } from './components/Reducers/UserContext';
import createPersistedState from 'use-persisted-state';
const useAppState = createPersistedState('data');

function App() {
    const [isLoggedIn, setLogger] = useAppState({
        active: false,
        user: '',
    });

    const value = useMemo(() => ({ isLoggedIn, setLogger }), [isLoggedIn, setLogger]);

    return (
        <UserContext.Provider value={value}>
            <div>{!isLoggedIn['active'] ? <GoogleLogger /> : <SiderApp />}</div>
        </UserContext.Provider>
    );
}

export default App;
